import API from "./index";

class ModalidadeContratoService {
  constructor() {
    this.path = "api/modalidadecontrato";
  }

  findAll({ page = 0, size = 10, descricao = "", situacao = null, tipoContrato = null }) {
    page = page - 1 < 0 ? 0 : page - 1; // Corrige a página para iniciar em 0
    const params = { page, size };

    if (descricao) params.descricao = descricao;
    if (situacao !== null) params.situacao = situacao;
    if (tipoContrato !== null) params.tipoContrato = tipoContrato;

    return API.get(this.path, { params });
  }

  findById(id) {
    return API.get(`${this.path}/${id}`);
  }

  create(data) {
    return API.post(this.path, data);
  }

  update(data) {
    return API.put(this.path, data);
  }

  delete(id) {
    return API.delete(`${this.path}/${id}`);
  }
}

export default new ModalidadeContratoService();
